/*
 *  Enable hover effects whenever a mouse cursor is moved, disable hover effects whenever a touch is detected.
 *  This should work basically in any browser and enables/disables hover styles as needed.
 */ 
ready().then(function() {
    function watchForHover() {
        // lastTouchTime is used for ignoring emulated mousemove events
        let lastTouchTime = 0

        function enableHover() {
            if (new Date() - lastTouchTime < 500) return
            document.body.classList.remove('has-no-hover');
        }

        function disableHover() {
            document.body.classList.add('has-no-hover');
        }

        function updateLastTouchTime() {
            lastTouchTime = new Date()
        }

        document.addEventListener('touchstart', updateLastTouchTime, true)
        document.addEventListener('touchstart', disableHover, true)
        document.addEventListener('mousemove', enableHover, true)

        enableHover();
    }

    watchForHover();
});